export interface BlogPost {
  id: string;
  title: string;
  date: string;
  excerpt: string;
  tags: string[];
  published: boolean;
}

export const blogPosts: BlogPost[] = [
  {
    id: "post-1",
    title: "Building a Terminal-Themed Portfolio with React and GSAP",
    date: "2026-04-01",
    excerpt: "A deep dive into creating a developer portfolio that feels like a terminal, using GSAP for smooth animations and Tailwind CSS for styling.",
    tags: ["React", "GSAP", "CSS", "Portfolio"],
    published: true,
  },
  {
    id: "post-2",
    title: "Why I Chose Rust for My Next Backend Project",
    date: "2026-03-15",
    excerpt: "Exploring the trade-offs between Rust, Python, and Node.js for building performant backend services, and why memory safety matters.",
    tags: ["Rust", "Backend", "Architecture"],
    published: true,
  },
  {
    id: "post-3",
    title: "Self-Hosting on a Raspberry Pi: A Complete Guide",
    date: "2026-03-01",
    excerpt: "Everything you need to know about setting up a Raspberry Pi as a personal web server, from OS installation to SSL certificates.",
    tags: ["DevOps", "Raspberry Pi", "Self-Hosting"],
    published: true,
  },
];
